import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostComgatePayment_status = z.any()
export type TagsPostComgatePayment_status = z.infer<typeof tagsPostComgatePayment_status>

export const bodyPostComgatePayment_status = z.object({ "merchant": z.string(), "test": z.string().optional(), "price": z.string().optional(), "curr": z.string().optional(), "refId": z.string(), "method": z.string().optional(), "transId": z.string(), "secret": z.string(), "status": z.union([z.literal("PAID"), z.literal("CANCELED"), z.literal("CANCELLED"), z.literal("AUTHORIZED"), z.literal("PENDING")]) })
export type BodyPostComgatePayment_status = z.infer<typeof bodyPostComgatePayment_status>

interface IPostComgatePayment_status extends BaseMethodType {
  tags: TagsPostComgatePayment_status,
  body: BodyPostComgatePayment_status
}
export const URL = '/comgate/payment-status'
export const validation = {
  post: {
    tags: tagsPostComgatePayment_status,
    body: bodyPostComgatePayment_status
  }
}
export interface ComgatePayment_status extends BaseRouteType {
  post: IPostComgatePayment_status
}